$(document).on("turbolinks:load", function () {
  // Fade out notifications after 3 seconds
  $('.fade').delay(3000).fadeOut();
});